export default __webpack_public_path__ + "static/media/ennovate_8.29051c1a.jpg";